import { Grid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { getChartData, getEmptyStateChart } from '../../../helpers/chartHelper';
import getColourSchemeBasedOnStatus from '../../../helpers/getColourSchemeBasedOnStatus';
import { Analytics } from '../../../hooks/useAnalyticsQuery';

const ServiceHistoryRequestSubmittedCompletedLineChart = (props: { data: Analytics; loadingDataInterval: Array<any> }) => {
  const { t } = useTranslation();
  const { data = {}, loadingDataInterval = [] } = props;

  const loadingData = getEmptyStateChart(loadingDataInterval, ['shr_submitted', 'shr_completed']);
  const chartData = getChartData(data, ['shr_submitted', 'shr_completed']);
  return (
    <Grid>
      <ResponsiveContainer aspect={3.1}>
        <LineChart
          width={500}
          height={300}
          data={chartData.length === 0 ? loadingData : chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            strokeWidth={4}
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.service_history_request.submitted_vs_completed.submitted.legend`)}
            type="monotone"
            dataKey="shr_submitted"
            stroke={getColourSchemeBasedOnStatus('submitted')}
          />
          <Line
            strokeWidth={4}
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.service_history_request.submitted_vs_completed.completed.legend`)}
            type="monotone"
            dataKey="shr_completed"
            stroke={getColourSchemeBasedOnStatus('completed')}
          />
        </LineChart>
      </ResponsiveContainer>
    </Grid>
  );
};

export default ServiceHistoryRequestSubmittedCompletedLineChart;
